<!-- 资源-选择试卷-吴影茹 -->
<template>
  <div>
    <!-- 标题 -->
    <div class="resource_select_title">选择试卷</div>
    <!-- 搜索 -->
    <div class="row_center question_select_box">
      <ChapterSelect placeholder="请选择教材" @select="textbookSelectHandler" :data="defaultTextbookData" v-model:reset="resetValue" width="100%" />
    </div>
    <div class="row_center" style="gap: 20px; margin-top: 10px">
      <a-input placeholder="请输入试卷名称" style="flex: 1" v-model:value="formModal.paperName" />
      <a-select v-model:value="formModal.paperType" :options="typeList2" style="flex: 1" placeholder="请选择试卷类型"></a-select>
    </div>
    <div class="row_between" style="margin-top: 15px">
      <a-select v-model:value="formModal.paperType1" :options="typeList1" style="flex: 1" placeholder="请选择"></a-select>
      <div class="row_center_end" style="flex: 1">
        <a-button @click="reset" class="button_margin_right">重置</a-button>
        <a-button @click="getList(true)" type="primary">搜索</a-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="paper_select_list" v-if="dataSource.length != 0">
      <div class="paper_select_item" v-for="(item, index) in dataSource" :key="index">
        <!-- 基础信息 -->
        <div class="row_center">
          <a-tag color="processing">{{
            typeList1.find((i) => {
              return i.value == item.paperType1
            })?.label || '-'
          }}</a-tag>
          <div class="paper_select_item_text">{{ item.textbookGroupName }}</div>
        </div>
        <!-- 试卷名称 -->
        <div class="paper_select_item_title">{{ item.paperName }}</div>
        <!-- 其他信息 -->
        <div class="row_wrap" style="gap: 15px">
          <!-- 试卷类型 -->
          <a-tag color="processing">{{
            typeList2.find((i) => {
              return i.value == item.paperType
            })?.label || '-'
          }}</a-tag>
          <!-- 考试时长-仅在线试卷有此信息 -->
          <div class="row_center" v-if="item.paperType1 == 1">
            <img src="../../assets/images/resource/paper/duration.png" class="paper_select_item_icon" />
            <div class="paper_select_item_text">{{ item.duration + '分钟' }}</div>
          </div>
          <!-- 是否乱序出题-仅在线试卷有此信息 -->
          <div class="row_center" v-if="item.paperType1 == 1 && item.isOrder">
            <img src="../../assets/images/resource/paper/out-of-order.png" class="paper_select_item_icon" />
            <div class="paper_select_item_text">乱序出题</div>
          </div>
          <!-- 是否含讲解视频 -->
          <div class="row_center" v-if="item.analysisVideoUrl && item.analysisVideoUrl != ''">
            <img src="../../assets/images/resource/paper/video.png" class="paper_select_item_icon2" />
            <div class="paper_select_item_text">含讲解视频</div>
          </div>
          <!-- 是否含答案-仅模拟试卷有此信息 -->
          <div class="row_center" v-if="item.paperType1 == 2 && item.analysisUrl && item.analysisUrl != ''">
            <img src="../../assets/images/resource/paper/answer.png" class="paper_select_item_icon" />
            <div class="paper_select_item_text">含答案</div>
          </div>
        </div>
        <!-- 总分 -->
        <div class="paper_select_item_text" v-if="item.paperType1 == 1" style="margin-top: 10px">
          {{ '总分：' + item.totalScore + '分' }}
        </div>
        <div class="row_between" style="margin-top: 20px">
          <!-- 创建人+创建时间 -->
          <div style="flex: 1">
            <div class="paper_select_item_text" style="margin-bottom: 8px">{{ '创建人：' + item.createBy }}</div>
            <div class="paper_select_item_text">{{ item.createTime }}</div>
          </div>
          <!-- 按钮 -->
          <div class="row_center">
            <a-button @click="detailHandler(item)" class="button_margin_right">预览</a-button>
            <a-button type="primary" :disabled="isSelected(item)" @click="selectHandler(item)">{{ isSelected(item) ? '已添加' : '添加' }}</a-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 空状态 -->
    <div v-else>
      <OyEmpty style="margin: 30px 0 70px 0" />
    </div>
    <!-- 分页 -->
    <div class="row_center_end">
      <a-pagination
        v-model:current="pageNum"
        v-model:pageSize="pageSize"
        :total="total"
        show-less-items
        :show-total="() => `共 ${total} 条`"
        @change="pageChange"
      />
    </div>
  </div>
</template>
            
<script setup lang="ts">
import { onMounted, ref, getCurrentInstance, nextTick, watch } from 'vue'
import * as api from './service'
import { useDict } from '@/composable/useDict'
const { getDictData } = useDict()

const props = defineProps({
  // 已选数据数据
  list: {
    type: Array as () => Array<any>,
    default: () => []
  },
  //   需要传入的章节信息参数
  defaultTextbookData: {
    type: Object,
    default: () => {}
  }
})

onMounted(async () => {
  typeList1.value = await getDictData('paper_type1')
  typeList2.value = await getDictData('paper_type')
  getList(true)
})
const emit = defineEmits(['update:list'])

// 列表数据
const dataSource = ref<any[]>([])
const formModal = ref<any>({
  paperType: null,
  paperType1: '1',
  paperName: ''
})

// 章节信息选择
const textbookData = ref<any>({})

// 获取试卷列表数据
// init 是否需要清空列表数据再拉取数据
const getList = (init = false) => {
  if (init) {
    dataSource.value = []
    pageNum.value = 1
    total.value = 0
  }

  for (const key in textbookData.value) {
    if (textbookData.value[key] === '' || textbookData.value[key] === null) {
      delete textbookData.value[key]
    }
  }
  for (const key in formModal.value) {
    if (formModal.value[key] === '' || formModal.value[key] === null) {
      delete formModal.value[key]
    }
  }

  api
    .testPaperList({ params: { ...textbookData.value, ...formModal.value, paperStatus: '2' }, pageNum: pageNum.value, pageSize: pageSize.value })
    .then((res) => {
      dataSource.value = res.data.list
      total.value = res.data.total
    })
}

// 分页配置
const pageNum = ref<Number>(1)
const pageSize = ref<Number>(5)
const total = ref<Number>(0)
const pageChange = (page: Number) => {
  pageNum.value = page
  getList()
}

// 选择章节信息
const textbookSelectHandler = (e) => {
  if (e[0]) textbookData.value.studyPeriod = e[0]
  if (e[1]) textbookData.value.gradeCode = e[1]
  if (e[2]) textbookData.value.subjectCode = e[2]
  if (e[3]) textbookData.value.volumeCode = e[3]
  if (e[4]) textbookData.value.versionId = e[4]
  if (e[5]) textbookData.value.textbookId = e[5]
  if (e[6]) textbookData.value.parentChapterId = e[6]
  textbookData.value.chapterId = e[7] || ''
}

const typeList1 = ref<any>([])
// 试卷类型
const typeList2 = ref<any>([])

// 已选试卷列表
const selectedList = ref<any>([])
// 是否已选
const isSelected = (item: any) => {
  return selectedList.value.some((i) => i.paperId === item.paperId)
}

// 预览
const previewVisible = ref(false)
const previewId = ref<string>('')
const detailHandler = (item: any) => {
  previewVisible.value = true
  previewId.value = item.paperId
}

// 选择
const selectHandler = (item: any) => {
  var index = selectedList.value.findIndex((i) => {
    return i.paperId == item.paperId
  })
  if (index == -1) {
    selectedList.value.push({ ...item })
  } else {
    selectedList.value.splice(index, 1)
  }

  emit('update:list', selectedList.value)
}

// 重置
const resetValue = ref(false)
const reset = () => {
  resetValue.value = true
  textbookData.value = {}
  formModal.value.paperType = null
  formModal.value.paperType1 = '1'
  formModal.value.paperName = ''
  getList(true)
}

watch(
  () => props.list,
  (newVal) => {
    if (newVal && newVal.length != 0) {
      selectedList.value = newVal.map((item) => {
        return { ...item }
      })
    }
  },
  { immediate: true, deep: true }
)

watch(
  () => props.defaultTextbookData,
  (newVal) => {
    if (Object.keys(newVal).length != 0) {
      if (newVal[0]) textbookData.value.studyPeriod = newVal[0]
      if (newVal[1]) textbookData.value.gradeCode = newVal[1]
      if (newVal[2]) textbookData.value.subjectCode = newVal[2]
      if (newVal[3]) textbookData.value.volumeCode = newVal[3]
      if (newVal[4]) textbookData.value.versionId = newVal[4]
      if (newVal[5]) textbookData.value.textbookId = newVal[5]
      if (newVal[6]) textbookData.value.parentChapterId = newVal[6]
      if (newVal[7]) textbookData.value.chapterId = newVal[7]
      getList(true)
    }
  },
  { immediate: true, deep: true }
)
</script>
            
<style lang="scss" scoped>
.question_select_box {
  margin-top: 20px;
  gap: 15px;
}
.paper_select_list {
  margin-top: 20px;
}
.paper_select_item {
  border-radius: 15px;
  border: 1px solid #e5e7eb;
  padding: 20px;
  margin-bottom: 20px;
}
.paper_select_item_text {
  font-size: 14px;
  color: #6b7280;
}
.paper_select_item_icon {
  width: 12px;
  height: 12px;
  margin-right: 5px;
}
.paper_select_item_icon2 {
  width: 14px;
  height: 12px;
  margin-right: 5px;
}
.paper_select_item_title {
  font-size: 16px;
  color: #111827;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 15px;
}
</style>